window.actualizarTablaAcondicionamientoPeriodo = null;

if (window.location.pathname === "/acondicionamiento/periodo") {

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    const tableBody = document.querySelector("#tablaAcondicionamientoPeriodo tbody");

    const num = n => (Number(n) || 0).toLocaleString('en-US');
    const fecha = f => { if (!f) return ''; return String(f).split('-').reverse().join('/'); };
    const txt = t => (t === null || t === undefined || String(t).trim() === '') ? '-' : String(t);
    const formatearTiempoEmpleado = function (minutos) {
        const totalMinutos = Math.max(0, Math.round(Number(minutos) || 0));
        const horas = Math.floor(totalMinutos / 60);
        const minutosRestantes = totalMinutos % 60;

        if (horas > 0 && minutosRestantes > 0) {
            return num(horas) + ' h ' + minutosRestantes + ' min';
        }
        if (horas > 0) {
            return num(horas) + ' h';
        }
        return minutosRestantes + ' min';
    };
    const escapeHtml = (str) => {
        str = str === null || str === undefined ? '' : String(str);
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    };

    const mainAcondicionamiento = document.querySelector('.mainDetalleAcondicionamiento');
    const esAdmin = mainAcondicionamiento ? mainAcondicionamiento.getAttribute('data-rol-admin') === '1' : false;

    const filtroOf = document.getElementById("filtroOfAcondicionamiento");
    const filtroCliente = document.getElementById("filtroClienteAcondicionamiento");
    const filtroReferencia = document.getElementById("filtroReferenciaAcondicionamiento");
    const filtroActividad = document.getElementById("filtroActividadAcondicionamiento");
    const filtroEstado = document.getElementById("filtroEstadoAcondicionamiento");

    let resultadoPeriodoAcondicionamiento = [];

    function debounce(callback, delay = 400) {
        let timeout;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(callback, delay);
        };
    }

    function normalizarTexto(valor) {
        return (valor === null || valor === undefined) ? '' : String(valor).toLowerCase();
    }

    function filtrarResultadoAcondicionamiento(resultado) {
        const textoOf = filtroOf ? normalizarTexto(filtroOf.value.trim()) : '';
        const textoCliente = filtroCliente ? normalizarTexto(filtroCliente.value.trim()) : '';
        const textoReferencia = filtroReferencia ? normalizarTexto(filtroReferencia.value.trim()) : '';
        const actividadSeleccionada = filtroActividad ? filtroActividad.value : '0';
        const estadoSeleccionado = filtroEstado ? filtroEstado.value : '0';

        return resultado.filter(function (item) {
            if (textoOf !== '') {
                const numeroOf = normalizarTexto(item.numeroOf);
                const numeroPedido = normalizarTexto(item.numeroPedido);
                if (numeroOf.indexOf(textoOf) === -1 && numeroPedido.indexOf(textoOf) === -1) {
                    return false;
                }
            }

            if (textoCliente !== '') {
                const cmnCliente = normalizarTexto(item.codigoSap);
                const nombreCliente = normalizarTexto(item.nombreSap);
                if (cmnCliente.indexOf(textoCliente) === -1 && nombreCliente.indexOf(textoCliente) === -1) {
                    return false;
                }
            }

            if (textoReferencia !== '') {
                const codigoArticulo = normalizarTexto(item.codigoArticulo);
                const descripcionArticulo = normalizarTexto(item.descripcionArticulo);
                if (codigoArticulo.indexOf(textoReferencia) === -1 && descripcionArticulo.indexOf(textoReferencia) === -1) {
                    return false;
                }
            }

            if (actividadSeleccionada !== '0' && actividadSeleccionada !== '') {
                if (normalizarTexto(item.nombreActividad) !== normalizarTexto(actividadSeleccionada)) {
                    return false;
                }
            }

            if (estadoSeleccionado !== '0' && estadoSeleccionado !== '') {
                const esActivo = Number(item.estado) === 1;
                if (estadoSeleccionado === '1' && !esActivo) {
                    return false;
                }
                if (estadoSeleccionado === '2' && esActivo) {
                    return false;
                }
            }

            return true;
        });
    }

    function skeletonTabla() {
        let html = '';
        for (let i = 0; i < 5; i++) {
            html += `<tr class="skeletonFila">
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
            </tr>`;
        }
        return html;
    }

    function renderTablaAcondicionamiento(resultado) {
        if (!tableBody) return;

        tableBody.innerHTML = "";
        tableBody.classList.remove('cargado');
        void tableBody.offsetWidth;
        tableBody.classList.add('cargado');

        if (resultado.length === 0) {
            tableBody.innerHTML = `
                <tr class="no-data">
                    <td colspan="13">
                        <div class="cont-no-data">
                            No se encontró información para este periodo.
                            <img class="icono-pequeño-gris" src="/public/build/img/icons/alerta.svg" alt="">
                        </div>
                    </td>
                </tr>
            `;
            return;
        }

        let html = '';
        resultado.forEach(function (item) {
            const esActivo = Number(item.estado) === 1;
            const estadoTexto = esActivo ? 'ACTIVO' : 'FINALIZADO';
            const claseEstado = esActivo ? 'tdVerde' : 'tdGris';

            const cumplimiento = Number(item.porcentajeCumplimiento) || 0;

            const pedido = txt(item.numeroPedido);
            const cmn = txt(item.codigoSap);

            const acciones =
                `<button type="button" class="btnAccionVer btnModal btnVerReporte" data-id="${item.idEncabezadoReporteAcondicionamiento}" data-modal="modalProduccionAcondicionamiento" title="Ver detalle del reporte">
                    <span>Ver</span>
                    <img src="/public/build/img/icons/flecha-derecha.svg" alt="ver">
                </button>` +
                (esAdmin ? `<button type="button" class="btnAccionDuplicar btnModal btnDuplicarReporteAcondicionamiento" data-id="${item.idEncabezadoReporteAcondicionamiento}" data-modal="modalDuplicarOrdenAcondicionamiento" title="Duplicar orden de trabajo">
                    <img src="/public/build/img/icons/copiar.svg" alt="duplicar">
                </button>` : '');

            html += `
                <tr>
                    <td>${fecha(item.fechaTrabajo)}</td>
                    <td>
                        <span class="datoPrincipalTabla">${escapeHtml(item.numeroOf)}</span>
                        ${pedido !== '-' ? `<span class="datoSecundarioTabla">Pedido ${escapeHtml(pedido)}</span>` : ''}
                    </td>
                    <td>
                        <span class="datoPrincipalTabla">${escapeHtml(txt(item.nombreSap))}</span>
                        ${item.codigoSap !== '-' ? `<span class="datoSecundarioTabla">${escapeHtml(item.codigoSap)}</span>` : ''}
                    </td>
                    <td>
                        <span class="datoPrincipalTabla">${escapeHtml(txt(item.descripcionArticulo))}</span>
                        ${item.codigoArticulo !== '-' ? `<span class="datoSecundarioTabla">${escapeHtml(item.codigoArticulo)}</span>` : ''}
                    </td>
                    <td class="datoPrincipalTabla">${escapeHtml(txt(item.nombreActividad))}</td>
                    <td>${num(item.unidadesRequeridas)}</td>
                    <td>${num(item.cantidadRecibida)}</td>
                    <td>${num(item.unidadesTrabajadas)}</td>
                    <td title="Tiempo acumulado de todos los operarios">${formatearTiempoEmpleado(item.totalMinutosEmpleados)}</td>
                    <td>${num(item.totalPersonasTrabajaron)}</td>
                    <td>${num(cumplimiento)}%</td>
                    <td><span class="${claseEstado}">${estadoTexto}</span></td>
                    <td class="contAccionesTabla">${acciones}</td>
                </tr>
            `;
        });

        tableBody.innerHTML = html;
    }

    function aplicarFiltrosAcondicionamiento() {
        const resultadoFiltrado = filtrarResultadoAcondicionamiento(resultadoPeriodoAcondicionamiento);
        renderTablaAcondicionamiento(resultadoFiltrado);
    }

    window.actualizarTablaAcondicionamientoPeriodo = function (mes, anio) {
        if (!tableBody) return;

        tableBody.innerHTML = skeletonTabla();

        const url = `/api/acondicionamiento/periodo?mes=${mes}&anio=${anio}`;

        fetch(url, requestOptions)
            .then(function (response) {
                if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
                return response.json();
            })
            .then(function (result) {
                const data = result.result;
                resultadoPeriodoAcondicionamiento = (data && data.resultado) ? data.resultado : [];

                aplicarFiltrosAcondicionamiento();

                if (typeof window.actualizarTableroAcondicionamientoPeriodo === 'function') {
                    window.actualizarTableroAcondicionamientoPeriodo(mes, anio);
                }
            })
            .catch(function (error) {
                console.error("Error en tabla acondicionamiento periodo:", error);
                tableBody.innerHTML = `
                    <tr class="no-data">
                        <td colspan="13">
                            <div class="cont-no-data">
                                No se pudo cargar la información del periodo.
                                <img class="icono-pequeño-gris" src="/public/build/img/icons/alerta.svg" alt="">
                            </div>
                        </td>
                    </tr>
                `;
                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta("No se pudo actualizar la tabla del periodo.", "alerta-roja");
                }
            });
    };

    const filtrarConDebounce = debounce(aplicarFiltrosAcondicionamiento, 400);

    if (filtroOf) {
        filtroOf.addEventListener("input", filtrarConDebounce);
    }
    if (filtroCliente) {
        filtroCliente.addEventListener("input", filtrarConDebounce);
    }
    if (filtroReferencia) {
        filtroReferencia.addEventListener("input", filtrarConDebounce);
    }
    if (filtroActividad) {
        filtroActividad.addEventListener("change", aplicarFiltrosAcondicionamiento);
    }
    if (filtroEstado) {
        filtroEstado.addEventListener("change", aplicarFiltrosAcondicionamiento);
    }

    const params = new URLSearchParams(window.location.search);
    window.actualizarTablaAcondicionamientoPeriodo(params.get('mes'), params.get('año'));
}
